module.exports = __webpack_public_path__ + "static/media/background.33545ec6.png";